import * as actions from "./actions";

let initialState = {
  enabled: undefined,
  fetching: false,
  fetched: false,
  sending: false,
  sent: false,
};

const autoinvest = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_AUTO_INVEST_STATUS_REQUEST:
      return Object.assign({}, state, {
        fetching: true,
      });
    case actions.GET_AUTO_INVEST_STATUS_SUCCESS:
      return Object.assign({}, state, {
        fetching: false,
        fetched: true,
        enabled: action.response,
      });
    case actions.GET_AUTO_INVEST_STATUS_ERROR:
      return Object.assign({}, state, {
        fetching: false,
        fetched: true,
        enabled: false,
      });
    case actions.ENABLE_AUTO_INVEST_REQUEST:
      return Object.assign({}, state, {
        sending: true,
      });
    case actions.ENABLE_AUTO_INVEST_SUCCESS:
      return Object.assign({}, state, {
        sending: false,
        sent: true,
        enabled: true,
      });
    case actions.DISABLE_AUTO_INVEST_REQUEST:
      return Object.assign({}, state, {
        sending: true,
      });
    case actions.DISABLE_AUTO_INVEST_SUCCESS:
      return Object.assign({}, state, {
        sending: false,
        sent: true,
        enabled: false,
      });
    default:
      return state;
  }
};

export default autoinvest;
